import URI from 'urijs'

import DevConfig from './config.dev.json'
import LocalConfig from './config.local.json'
import ProdConfig from './config.prod.json'
import StagingConfig from './config.staging.json'

// Left side is the CCMS/SSO env name
// Right side is the Lego name
const LOCAL = 'dev'
const DEV = 'stage'
const STAGING = 'staging'
const PROD = 'prod'
export type LegoEnvType = 'dev' | 'stage' | 'staging' | 'prod'
// Rest of SSO code uses left side as the convention

const BASE_DOMAIN: string = URI(window.location).origin()

const getCurrentEnv = () => window.lego.config.WSAUTH_ENV as LegoEnvType

const isLocal = (env = getCurrentEnv()) => env === LOCAL
const isDev = (env = getCurrentEnv()) => env === DEV
const isStaging = (env = getCurrentEnv()) => env === STAGING
const isProd = (env = getCurrentEnv()) => env === PROD
const shouldEmulateFirebase = () => isLocal()

const getAppConfig = (env = getCurrentEnv()) => {
  if (!env) {
    throw new Error('env is required')
  }

  const result = {
    [LOCAL]: LocalConfig,
    [DEV]: DevConfig,
    [STAGING]: StagingConfig,
    [PROD]: ProdConfig,
  }[env]

  if (!result) {
    throw new Error('Invalid env and config provided')
  }
  return result.wsConfig
}

export {
  BASE_DOMAIN,
  LOCAL,
  DEV,
  STAGING,
  PROD,
  getCurrentEnv,
  getAppConfig,
  isLocal,
  isDev,
  isStaging,
  isProd,
  shouldEmulateFirebase,
}
